//var Math = require('mathjs')
/**
* Mathオブジェクトを拡張 
*/
var Math = window.Math || {};


/**
* 与えられた値の小数点以下の桁数を返す 
* multiply, subtractで使用
* 
* 例)
*   10.12  => 2  
*   99.999 => 3
*   33.100 => 1
*/
Math._getDecimalLength = function(value) {
  var list = (value + '').split('.'), result = 0;
  if (list[1] !== undefined  && list[1].length > 0) {
    result = list[1].length;
  }
  return result;
};


/**
* 乗算処理
*
* value1, value2から小数点を取り除き、整数値のみで乗算を行う。 
* その後、小数点の桁数Nの数だけ10^Nで除算する
*/
Math.multiply = function(value1, value2) {
  var intValue1 = +(value1 + '').replace('.', ''),
      intValue2 = +(value2 + '').replace('.', ''),
      decimalLength = Math._getDecimalLength(value1) + Math._getDecimalLength(value2),
      result;

  result = (intValue1 * intValue2) / Math.pow(10, decimalLength);

  return result;
};


/**
* 減算処理
*
* value1,value2を整数値に変換して減算
* その後、小数点の桁数分だけ小数点位置を戻す
*/
Math.subtract = function(value1, value2) {
  var max = Math.max(Math._getDecimalLength(value1), Math._getDecimalLength(value2)),
  k = Math.pow(10, max);
  return (Math.multiply(value1, k) - Math.multiply(value2, k)) / k;
};


/**
* 加算処理
*
* value1,value2を整数値に変換して加算
* その後、小数点の桁数分だけ小数点位置を戻す
*/
Math.addition = function(value1, value2) {
  var max = Math.max(Math._getDecimalLength(value1), Math._getDecimalLength(value2)),
  k = Math.pow(10, max);
  return (Math.multiply(value1, k) + Math.multiply(value2, k)) / k;
};


var _reqkinn = '';
var _reqrate = '';
var _reqnenn = '';

var o = "http://www.w3.org/2000/svg";

window.calc_g = calc_g;

function calc_g(ks) {
 var op = {};
 op.ks = ks; //1:終価係数 2:現価係数 3:年金終価係数 4:年金現価係数 5:減債基金係数 6:資本回収係数
 op.rk = 2; //係数小数点以下 0:3桁 1:5桁 2:7桁 3:9桁
 op.rf = 0; //係数まるめ処理 0:Round 1:Ceil 2:Floor
 op.kk = 0; //金額小数点以下 0:0桁 1:2桁 2:4桁
 op.kf = 0; //金額まるめ処理 0:Round 1:Ceil 2:Floor
 op.ri = 4 ; // 年利率％小数点以下桁数
 op.rm = 20 ; // 最大年利率
 op.nw = 11 ; // 表示年数
 op.nm = 50 ; // 最大年数

 var reqkinn = document.getElementById('reqkinn-g');
 var reqrate = document.getElementById('reqrate-g');
 var reqnenn = document.getElementById('reqnenn-g');
 var msgarea = document.getElementById('msgarea-g');

// ^ 入力の先頭にマッチします。
// $ 入力の末尾にマッチします。
// * 直前の文字の 0 回以上の繰り返しにマッチします。{0,}に相当します。
// + 直前の文字の 1 回以上の繰り返しにマッチします。{1,}に相当します。
// ? 直前の文字の 0 回か 1 回の出現にマッチします。{0,1}に相当します。
//

 var ma = false;
 switch (ks) {
 case 1 :
  ma = reqkinn.value.match(/^([0-9]{1,5})$/);
  break;
 case 3 :
 case 4 :
  ma = reqkinn.value.match(/^([0-9]{1,4})$/);
  break;
 case 2 :
 case 5 :
 case 6 :
  ma = reqkinn.value.match(/^([0-9]{1,8})$/);
  break;
 }

 if(ma){
  _reqkinn = reqkinn.value;
 }else if(reqkinn.value.length == 0){
  reqkinn.value = '' ;
  _reqkinn = reqkinn.value;
 }else{
  reqkinn.value = _reqkinn;
 }
 op.ikin = _reqkinn;

 if(reqrate.value.match(/^([0-9]{0,2})(\.[0-9]{0,4})?$/)){
  if (stoRate(reqrate.value)>op.rm) {
   reqrate.value = _reqrate;
  } else {
   _reqrate = reqrate.value ;
  }
 }else if(reqrate.value.length == 0){
  reqrate.value = '' ;
  _reqrate = reqrate.value;
 }else{
  reqrate.value = _reqrate;
 }
 op.rate = _reqrate;

 if(reqnenn.value.match(/^([0-9]{1,2})$/)){
  if (stoNumber(reqnenn.value)>op.nm){
   reqnenn.value = _reqnenn;
  } else {
   _reqnenn = reqnenn.value;
  }
 }else if(reqnenn.value.length == 0){
  reqnenn.value = '' ;
  _reqnenn = reqnenn.value;
 }else{
  reqnenn.value = _reqnenn;
 }
 op.nenn = _reqnenn;

 var rk0 = document.getElementById('rk0-g');
 var rk1 = document.getElementById('rk1-g');
 var rk2 = document.getElementById('rk2-g');
 var rk3 = document.getElementById('rk3-g');
 if (rk0.checked) {
  op.rk = 0;
 } else if (rk1.checked) {
  op.rk = 1;
 } else if (rk2.checked) {
  op.rk = 2;
 } else if (rk3.checked) {
  op.rk = 3;
 }

 var rf0 = document.getElementById('rf0-g');
 var rf1 = document.getElementById('rf1-g');
 var rf2 = document.getElementById('rf2-g');
 if (rf0.checked) {
  op.rf = 0;
 } else if (rf1.checked) {
  op.rf = 1;
 } else if (rf2.checked) {
  op.rf = 2;
 }

 var kk0 = document.getElementById('kk0-g');
 var kk1 = document.getElementById('kk1-g');
 var kk2 = document.getElementById('kk2-g');
 if (kk0.checked) {
  op.kk = 0;
 } else if (kk1.checked) {
  op.kk = 1;
 } else if (kk2.checked) {
  op.kk = 2;
 }

 var kf0 = document.getElementById('kf0-g');
 var kf1 = document.getElementById('kf1-g');
 var kf2 = document.getElementById('kf2-g');
 if (kf0.checked) {
  op.kf = 0;
 } else if (kf1.checked) {
  op.kf = 1;
 } else if (kf2.checked) {
  op.kf = 2;
 }
 
 values = mainCalc(op);

 for (var ix = 0; ix < 11; ix++) {
  for (var jx = 0; jx < 3; jx++) {
   var roco = 'ro' + ix + 'co' + jx + '-g';
   document.getElementById(roco).innerHTML = values[ix][jx];
   if (values[ix][0] == op.nenn){
    document.getElementById(roco).style.backgroundColor = '#ffe8d1';
    document.getElementById(roco).style.fontWeight = 'bold';
   } else {
    document.getElementById(roco).style.backgroundColor = '#d1ffd1';
    document.getElementById(roco).style.fontWeight = 'normal';
   }
   document.getElementById(roco).style.color = '#000000';
  }
 }
 
     //
    var g = {};
    // svg領域サイズ
    g.svgWidth = 500;
    g.svgHeight = 500;
    // マージン領域サイズ
    g.marginWidth = 100;
    g.marginRight = 60;
    g.marginHeight = 60;
    // グラフ描画領域サイズ
    g. maxWidth = g.svgWidth - g.marginWidth - g.marginRight;
    g. maxHeight = g.svgHeight - g.marginHeight * 2;
    var svg = document.getElementById('osvg');
    // svgクリア
    var parentElement = svg.parentElement
    var emptySvg = svg.cloneNode(false);
    parentElement.removeChild(svg);
    parentElement.appendChild(emptySvg);
    svg = emptySvg;
    // 軸名と位置
    g.verticalAxis = "係数";
    g.verticalAxis = "縦軸：" + g.verticalAxis;
    g.holizontalAxis = "年数";
    g.holizontalAxis = "横軸：" + g.holizontalAxis;
    g.topX = 25;
    g.topY = 25;
    g.bottomX = g.svgWidth - 20;
    g.bottomY = g.svgHeight -10;
    // X軸、Y軸の最小値と最大値
    g.minX = 1;
    g.maxX = 10;
    g.minY = 1;
    g.maxY = 10;
    // 目盛ラベルの増分
    g.stepX = 1;
    g.stepY = 10;
    // 累乗（縮尺）
    g.powerX = 0;
    g.powerY = -1;

    g.minX = values[0][0];
    g.maxX = values[values.length-1][0];
    var va = stoRate(values[0][2]);
    var vb = stoRate(values[values.length-1][2]);
    var vmarks = 10;
    if(va==vb){
        var vmin = 0;
        var vmax = vb;
        var vmarks = 1;
    }else if(va<vb){
        var vmin = va;
        var vmax = vb;
    }else{
        var vmin = vb;
        var vmax = va;
    }
    var vminlen = Math._getDecimalLength(vmin);
    var vmaxlen = Math._getDecimalLength(vmax);
    if(vminlen>vmaxlen){
        g.powerY = vminlen * -1;
    }else{
        g.powerY = vmaxlen * -1;
    }
    vmin = Math.floor(vmin/Math.pow(10, g.powerY));
    vmax = Math.ceil(vmax/Math.pow(10, g.powerY));
    var vc = Math.subtract(vmax, vmin);
    var vclen = (vc+"").length * -1;
    g.minY = Math.ceil(Math.floor(Math.multiply(vmin, Math.pow(10, vclen+1)))/Math.pow(10, vclen+1));
    g.maxY = Math.ceil(Math.ceil(Math.multiply(vmax, Math.pow(10, vclen+1)))/Math.pow(10, vclen+1));
    g.stepY = Math.subtract(g.maxY, g.minY)/vmarks;
    if(values[0][3]==1){
        drawAxis(svg, g);
        drawGraph(svg, g, values);
    }
}

function mainCalc(op) {
var _ikin = stoNumber(op.ikin);
var _rate = stoFixedRateInt(op.rate, op.ri);
var _rate0 = stoRate(op.rate)/Math.pow(10, 2);
var _nenn = stoNumber(op.nenn);
var _p0 = Math.pow(10, op.ri);
var _p2 = Math.pow(10, op.ri+2);
var _bd = BigNumber(_p2).plus(_rate);
var _ba = BigNumber(_bd).div(_p2);

var cikin = false;
if (_ikin > 0) {
 cikin = true;
}
var crate = false;
if (_rate > 0) {
 crate = true;
}
var cnenn = false;
if (_nenn > 0) {
 cnenn = true;
} else {
 _nenn = 1;
}

switch (op.rk) {
 case 0 : _rn = 3; break;
 case 1 : _rn = 5; break;
 case 2 : _rn = 7; break;
 case 3 : _rn = 9; break;
 default: _rn = 7; break;
}

switch (op.kk) {
 case 0 : _kn = 0; break;
 case 1 : _kn = 2; break;
 case 2 : _kn = 4; break;
 default: _kn = 0; break;
}

var kesu = 0;
var okin = 0;
var values = [];

if (_nenn < Math.floor(op.nw/2) + 1) {
 _sn = 1;
 _en = op.nw;
} else if (_nenn + Math.floor(op.nw/2) > op.nm) {
 _sn = op.nm - op.nw + 1;
 _en = op.nm;
} else {
 _sn = _nenn - Math.floor(op.nw/2);
 _en = _sn + op.nw - 1;
}

for (var ix = _sn; ix < _en + 1; ix ++) {
 if (crate) {
 kesu = calculateFactor(op, _rn, _ba, _rate, ix);
 if (cikin) {
 okin = r(Math.multiply(_ikin * _p0, stoRate(kesu)), _kn, op.kf);
 values.push([ ix, okin, kesu, 1 ]);
 } else {
 values.push([ ix, '──────', kesu, 1 ]);
 }
 } else {
 values.push([ ix, '──────', '──────' , 0 ]);
 }
};

return values;
}


function calculateFactor(op, rn, ba, rate, nenn) {

let kesu = 0;

switch (op.ks) {
//1:終価係数
case 1 :

//  kesu = r(Math.pow(ba, nenn), rn, op.rf);

  var _c = BigNumber(ba).pow(nenn);
  kesu = r(BigNumber(_c).toNumber(), rn, op.rf);

 break;

//  2:現価係数
case 2 :

//  var _t = Math.pow(ba, nenn);
//  var _c = 1 / _t;
//  var _cd = Math.floor(Math.multiply(_c, Math.pow(10, 16)));
//  kesu = r(_cd / Math.pow(10, 16), rn, op.rf);
//  kesu = r(Math.pow(ba, -1*nenn), rn, op.rf);

  var _t = BigNumber(ba).pow(nenn);
  var _c = BigNumber(1).div(_t);
  kesu = r(BigNumber(_c).toNumber(), rn, op.rf);

  break;

//3:年金終価係数
case 3 :

//  var rate0 = rate/Math.pow(10, op.ri + 2);
//  var _c = Math.pow(ba, nenn);
//  kesu = r((_c - 1)/rate0, rn, op.rf);

  var rate0 = BigNumber(rate).div(Math.pow(10, op.ri + 2));
  var _c = BigNumber(ba).pow(nenn);
  var _s = BigNumber(_c).minus(1);
  var _k = BigNumber(_s).div(rate0);
  kesu = r(BigNumber(_k).toNumber(), rn, op.rf);

 break;

//4:年金現価係数
case 4 :

//  var rate0 = rate/Math.pow(10, op.ri + 2);
//  var _c = Math.pow(ba, -1*nenn);
//  var _t = Math.pow(ba, nenn);
//  var _c = 1 / _t;
//  var _cd = Math.floor(Math.multiply(_c, Math.pow(10, 16)));
//  _c = _cd / Math.pow(10, 16);
//  kesu = r((1 - _c)/rate0, rn, op.rf);

  var rate0 = BigNumber(rate).div(Math.pow(10, op.ri + 2));
  var _t = BigNumber(ba).pow(nenn);
  var _c = BigNumber(1).div(_t);
  var _s = BigNumber(1).minus(_c);
  var _k = BigNumber(_s).div(rate0);
  kesu = r(BigNumber(_k).toNumber(), rn, op.rf);

 break;

//5:減債基金係数
case 5 :

//  var rate0 = rate/Math.pow(10, op.ri + 2);
//  var _c = Math.pow(ba, nenn);
//  kesu = r(rate0/(_c - 1), rn, op.rf);

  var rate0 = BigNumber(rate).div(Math.pow(10, op.ri + 2));
  var _c = BigNumber(ba).pow(nenn);
  var _s = BigNumber(_c).minus(1);
  var _k = BigNumber(rate0).div(_s);
  kesu = r(BigNumber(_k).toNumber(), rn, op.rf);

 break;

//6:資本回収係数
case 6 :

//  var rate0 = rate/Math.pow(10, op.ri + 2);
//  var _c = Math.pow(ba, -1*nenn);
//  var _t = Math.pow(ba, nenn);
//  var _c = 1 / _t;
//  var _cd = Math.floor(Math.multiply(_c, Math.pow(10, 16)));
//  op.rf == 2 ? _cd += 10 : _cd -= 5;
//  _c = _cd / Math.pow(10, 16);
//  kesu = r(rate0/(1 - _c), rn, op.rf);

  var rate0 = BigNumber(rate).div(Math.pow(10, op.ri + 2));
  var _t = BigNumber(ba).pow(nenn);
  var _c = BigNumber(1).div(_t);
  var _s = BigNumber(1).minus(_c);
  var _k = BigNumber(rate0).div(_s);
  kesu = r(BigNumber(_k).toNumber(), rn, op.rf);

 break;
}

return kesu;
}


// (){} まるめ処理
function r(number, n, f) {
 switch (f) {
  case 0 :
   result = roundFormat( number, n );
   break;
  case 1 :
   result = ceilFormat( number, n );
   break;
  case 2 :
   result = floorFormat( number, n );
   break;
  default:
   result = number;
   break;
 }
 return sepCurr(result);
}
// (){} シフト
function shift(number, precision, reverseShift) {
 if (reverseShift) {
  precision = -precision;
 }
 var numArray = ("" + number).split("e");
 return +(numArray[0] + "e" + (numArray[1] ? (+numArray[1] + precision) : precision));
}
// (){} 切り上げ
function ceilFormat( number, n ) {
return fixedRate(shift(Math.ceil(shift(number, n, false)), n, true), n);
}
// (){} 四捨五入
function roundFormat( number, n ) {
return fixedRate(shift(Math.round(shift(number, n, false)), n, true), n);
}
// {}{} 切り捨て
function floorFormat( number, n ) {
return fixedRate(shift(Math.floor(shift(number, n, false)+0.1), n, true), n);
}
// (){} 数値表現（整数）
function stoNumber ( numvalue ) {
if(numvalue.length == 0){
return 0;
}else{
return parseInt(numvalue.replace(/,/g, ''));
}
}
// (){} 数値表現（浮動小数）
function stoRate ( numvalue ) {
if(numvalue.length == 0){
return 0;
}else{
return parseFloat('0'+numvalue.replace(/,/g, ''));
}
}
// (){} 小数点以下ゼロ付加
function fixedRate ( numvalue, n ) {
p = (numvalue + '.').split('.');
if(p[0].length == 0){
p[0] = '0' ;
}
if (n>0) {
 return p[0] + '.' + (p[1] + Array(n+1).join('0')).substr(0, n);
} else {
 return p[0];
}
}
// (){} 整数表現
function stoRateInt ( numvalue ) {
p = (numvalue + '.').split('.');
return parseInt(p[0]+p[1]);
}
// (){} カンマ付加 
function sepCurr ( numvalue ) {
return numvalue.replace(/^(-?[0-9]+)(?=\.|$)/, function(s){ return s.replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g, '$1,');}); 
}
// (){} シフト後、整数表現
function stoFixedRateInt ( numvalue, n ) {
 var p = (numvalue + '.').split('.');
 if(p[0].length == 0){
  p[0] = '0' ;
 }
 var q = (p[0] + '.' + (p[1] + Array(n+1).join('0')).substr(0, n)  + '.').split('.');
 return parseInt(q[0]+q[1]);
}
//
function drawAxis(svg, g){
    // X軸の拡大縮小率
    if(g.minX>0){
        g.scaleX = Math.floor(g.maxWidth/((Math.abs(g.maxX)-Math.abs(g.minX))/g.stepX+1));
        g.maxWidth = g.scaleX * ((Math.abs(g.maxX)-Math.abs(g.minX))/g.stepX+1);
    }else if(g.maxX<0){
        g.scaleX = Math.floor(g.maxWidth/((Math.abs(g.minX)-Math.abs(g.maxX))/g.stepX+1));
        g.maxWidth = g.scaleX * ((Math.abs(g.minX)-Math.abs(g.maxX))/g.stepX+1);
    }else{
        g.scaleX = Math.floor(g.maxWidth/((Math.abs(g.minX)+Math.abs(g.maxX))/g.stepX));
        g.maxWidth = g.scaleX * ((Math.abs(g.minX)+Math.abs(g.maxX))/g.stepX);
    }
    // Y軸の拡大縮小率
    if(g.minY>0){
        g.scaleY = Math.floor(g.maxHeight/((Math.abs(g.maxY)-Math.abs(g.minY))/g.stepY+1));
        g.maxHeight = g.scaleY * ((Math.abs(g.maxY)-Math.abs(g.minY))/g.stepY+1);
    }else if(g.maxY<0){
        g.scaleY = Math.floor(g.maxHeight/((Math.abs(g.minY)-Math.abs(g.maxY))/g.stepY+1));
        g.maxHeight = g.scaleY * ((Math.abs(g.minY)-Math.abs(g.maxY))/g.stepY+1);
    }else{
        g.scaleY = Math.floor(g.maxHeight/((Math.abs(g.minY)+Math.abs(g.maxY))/g.stepY));
        g.maxHeight = g.scaleY * ((Math.abs(g.minY)+Math.abs(g.maxY))/g.stepY);
    }
   // 原点の位置
    g.offsetX = g.marginWidth;
    // 左上が 0
    g.offsetY = g.maxHeight + g.marginHeight; 
    if(g.minX<0){
        g.offsetX += Math.abs(g.minX)*g.scaleX;
        if(g.maxX<0){
            g.offsetX -= (Math.abs(g.maxX)-1)*g.scaleX;
        }
    }
    if(g.minY<0){
        g.offsetY -= Math.abs(g.minY)*g.scaleY; 
        if(g.maxY<0){
            g.offsetY += (Math.abs(g.maxY)-1)*g.scaleY;
        }
    }
    // 外枠
    var e=document.createElementNS(o, "rect");
    e.setAttribute("x", 1);
    e.setAttribute("y", 1);
    e.setAttribute("width", g.svgWidth-2);
    e.setAttribute("height", g.svgHeight-2);
    e.setAttribute("stroke", "#000000");
    e.setAttribute("stroke-width", 1);
    e.setAttribute("fill", "none");
    svg.appendChild(e);
    // X軸、Y軸
    var e = document.createElementNS(o,"line");
    e.setAttribute("stroke","#000000");
    e.setAttribute("stroke-width",1);
    e.setAttribute("x1",g.marginWidth);
    e.setAttribute("y1",g.offsetY);
    e.setAttribute("x2",g.marginWidth + g.maxWidth);
    e.setAttribute("y2",g.offsetY);
    svg.appendChild(e);
    var e = document.createElementNS(o,"line");
    e.setAttribute("stroke","#000000");
    e.setAttribute("stroke-width",1);
    e.setAttribute("x1",g.offsetX);
    e.setAttribute("y1",g.marginHeight);
    e.setAttribute("x2",g.offsetX);
    e.setAttribute("y2",g.marginHeight + g.maxHeight);
    svg.appendChild(e);
    // X軸の目盛
    var markY = 3;
    if(g.maxY<=0){
        markY = -3;
    }
    for(var i=g.marginWidth; i<=g.marginWidth+g.maxWidth; i+=g.scaleX){
        if((i!=g.offsetX) || (g.minX<0 && g.maxX>0) || (g.minX==0 && (g.maxY<0 || g.minY>0)) || (g.maxX==0 && (g.maxY<0 || g.minY>0))){
            var e = document.createElementNS(o,"line");
            e.setAttribute("stroke","#000000");
            e.setAttribute("stroke-width",1);
            e.setAttribute("x1",i);
            e.setAttribute("y1",g.offsetY);
            e.setAttribute("x2",i);
            e.setAttribute("y2",g.offsetY+markY);
            svg.appendChild(e);
        }
    }
    // X軸のラベル
    var textBaseline = 10; //"top";
    var textAlign = -5; //"center";
    var labelY = 5;
    if(g.maxY<=0){
        textBaseline = 0; //"bottom";
        labelY = -5;
    }
    var numX = 0;
    var oX = g.offsetX;
    if(g.minX > 0){
        numX = g.minX - g.stepX;
        oX = g.offsetX + g.scaleX;
    }
    for(var i=oX; i<=g.marginWidth+g.maxWidth; i+=g.scaleX){
        if(i!=g.offsetX){
            numX += g.stepX;
            var e = document.createElementNS(o,"text");
            e.setAttribute("style","font-size:10px;");
            e.setAttribute("fill","#000000");
            e.textContent = fixedRate(Math.multiply(numX, Math.pow(10, g.powerX)), Math.multiply(g.powerX, -1));
            var len = e.textContent.length * textAlign;
            e.setAttribute("x",i+len+5);
            e.setAttribute("y",g.offsetY+labelY+textBaseline);
            svg.appendChild(e);
        }
    }
    var numX = 0;
    var oX = g.offsetX;
    if(g.maxX<0){
        numX = g.maxX + g.stepX;
        oX = g.offsetX - g.scaleX;
    }
    for(var i=oX; i>=g.marginWidth; i-=g.scaleX){
        if(i!=g.offsetX){
            numX -= g.stepX;
            var e = document.createElementNS(o,"text");
            e.setAttribute("style","font-size:10px;");
            e.setAttribute("fill","#000000");
            e.textContent = fixedRate(Math.multiply(numX, Math.pow(10, g.powerX)), Math.multiply(g.powerX, -1));
            var len = e.textContent.length * textAlign;
            e.setAttribute("x",i+len+5);
            e.setAttribute("y",g.offsetY+labelY+textBaseline);
            svg.appendChild(e);
        }
    }
    // Y軸の目盛
    var markX = 3;
    if(g.maxX<=0){
        markX = -3;
    }
    for(var i=g.marginHeight; i<=g.maxHeight+g.marginHeight; i+=g.scaleY){
        if((i!=g.offsetY) || (g.minY<0 && g.maxY>0) || (g.minY==0 && (g.maxX<0 || g.minX>0)) || (g.maxY==0 && (g.maxX<0 || g.minX>0))){
            var e = document.createElementNS(o,"line");
            e.setAttribute("stroke","#000000");
            e.setAttribute("stroke-width",1);
            e.setAttribute("x1",g.offsetX-markX);
            e.setAttribute("y1",i);
            e.setAttribute("x2",g.offsetX);
            e.setAttribute("y2",i);
            svg.appendChild(e);
        }
    }
    // Y軸のラベル
    var textBaseline = 2; //"middle";
    var textAlign = -6; //"right";
    var labelX = 5;
    if(g.maxX<=0){
        textAlign = 0; //"left";
        labelX = -5;
    }
    var numY = 0;
    var j = 0;
    var oY = g.offsetY;
    if(g.maxY<0){
        numY = Math.addition(g.maxY, g.stepY);
        oY = g.offsetY + g.scaleY;
    }
    for(var i=oY; i<=g.maxHeight+g.marginHeight; i+=g.scaleY){
        if(i!=g.offsetY){
        	j += 1;
            var e = document.createElementNS(o,"text");
            e.setAttribute("style","font-size:10px;");
            e.setAttribute("fill","#000000");
//            e.textContent = fixedRate(Math.multiply(Math.subtract(numY, Math.multiply(g.stepY, j)), Math.pow(10, g.powerY)), Math.multiply(g.powerY, -1));
            e.textContent = fixedRate(Math.subtract(numY, Math.multiply(g.stepY, j))/Math.pow(10, Math.multiply(g.powerY, -1)), Math.multiply(g.powerY, -1));
            var len = e.textContent.length * textAlign;
            e.setAttribute("x",g.offsetX-labelX+len);
            e.setAttribute("y",i+textBaseline);
            svg.appendChild(e);
        }
    }
    var numY = 0;
    var j = 0;
    var oY = g.offsetY;
    if(g.minY>0){
        numY = Math.subtract(g.minY, g.stepY);
        oY = g.offsetY - g.scaleY;
    }
    for(var i=oY; i>=g.marginHeight; i-=g.scaleY){
        if(i!=g.offsetY){
        	j += 1;
            var e = document.createElementNS(o,"text");
            e.setAttribute("style","font-size:10px;");
            e.setAttribute("fill","#000000");
//            e.textContent = fixedRate(Math.multiply(Math.addition(numY, Math.multiply(g.stepY, j)), Math.pow(10, g.powerY)), Math.multiply(g.powerY, -1));
            e.textContent = fixedRate(Math.addition(numY, Math.multiply(g.stepY, j))/Math.pow(10, Math.multiply(g.powerY, -1)), Math.multiply(g.powerY, -1));
            var len = e.textContent.length * textAlign;
            e.setAttribute("x",g.offsetX-labelX+len);
            e.setAttribute("y",i+textBaseline);
            svg.appendChild(e);
        }
    }
    // 原点のラベル
    if(g.minX<0 && g.minY<0 && g.maxX>0 && g.maxY>0){
        labelX = -5;
        textAlign = -8; //"right";
        labelY = 5;
        textBaseline = 10; //"top";
        var e = document.createElementNS(o,"text");
        e.setAttribute("style","font-size:10px;");
        e.setAttribute("fill","#000000");
        e.textContent = 0;
        e.setAttribute("x",g.offsetX+labelX+textAlign);
        e.setAttribute("y",g.offsetY+labelY+textBaseline);
        svg.appendChild(e);
    }
    else if(g.minX==0 && g.minY==0){
        labelX = -5;
        textAlign = -8; //"right";
        labelY = 5;
        textBaseline = 10; //"top";
        var e = document.createElementNS(o,"text");
        e.setAttribute("style","font-size:10px;");
        e.setAttribute("fill","#000000");
        e.textContent = 0;
        e.setAttribute("x",g.offsetX+labelX+textAlign);
        e.setAttribute("y",g.offsetY+labelY+textBaseline);
        svg.appendChild(e);
    }
    else if(g.maxX==0 && g.maxY==0){
        labelX = 10;
        textAlign = 0; //"left";
        labelY = -5;
        textBaseline = 0; //"bottom";
        var e = document.createElementNS(o,"text");
        e.setAttribute("style","font-size:10px;");
        e.setAttribute("fill","#000000");
        e.textContent = 0;
        e.setAttribute("x",g.offsetX+labelX+textAlign);
        e.setAttribute("y",g.offsetY+labelY+textBaseline);
        svg.appendChild(e);
    }
    else if((g.minX<0 && g.maxX>0) || (g.minX==0 && (g.maxY<0 || g.minY>0)) || (g.maxX==0 && (g.maxY<0 || g.minY>0))){
        labelY = 5;
        textBaseline = 10; //"top";
        labelX = 0;
        textAlign = -5/2; //"center";
        if(g.maxY<=0){
            labelY = -5;
            textBaseline = 0; //"bottom";
        }
        var e = document.createElementNS(o,"text");
        e.setAttribute("style","font-size:10px;");
        e.setAttribute("fill","#000000");
        e.textContent = 0;
        e.setAttribute("x",g.offsetX+labelX+textAlign);
        e.setAttribute("y",g.offsetY+labelY+textBaseline);
        svg.appendChild(e);
    }
    else if((g.minY<0 && g.maxY>0) || (g.minY==0 && (g.maxX<0 || g.minX>0)) || (g.maxY==0 && (g.maxX<0 || g.minX>0))){
        labelY = 0;
        textBaseline = 5; //"middle";
        labelX = -5;
        textAlign = -8; //"right";
        if(g.maxX<=0){
            labelX = 10;
            textAlign = 0; //"left";
        }
        var e = document.createElementNS(o,"text");
        e.setAttribute("style","font-size:10px;");
        e.setAttribute("fill","#000000");
        e.textContent = 0;
        e.setAttribute("x",g.offsetX+labelX+textAlign);
        e.setAttribute("y",g.offsetY+labelY+textBaseline);
        svg.appendChild(e);
    }
    // 軸名（左上）
    var e = document.createElementNS(o,"text");
    e.setAttribute("style","font-size:16px;");
    e.setAttribute("fill","#000000");
    if(g.maxX<=0 && g.maxY<=0){
        e.textContent = g.holizontalAxis;
    }else{
        e.textContent = g.verticalAxis;
    }
    e.setAttribute("x",g.topX);
    e.setAttribute("y",g.topY);
    svg.appendChild(e);
    // 軸名（右下）
    var e = document.createElementNS(o,"text");
    e.setAttribute("style","font-size:16px;");
    e.setAttribute("fill","#000000");
    if(g.maxX<=0 && g.maxY<=0){
        e.textContent = g.verticalAxis;
        len = g.holizontalAxis.length * 16;
    }else{
        e.textContent = g.holizontalAxis;
        len = g.holizontalAxis.length * 16;
    }
    e.setAttribute("x",g.bottomX-len);
    e.setAttribute("y",g.bottomY);
    svg.appendChild(e);
}
//
function drawGraph(svg, g, v){
    var x1 = g.scaleX + g.offsetX;
    if(g.minY==0){
//        var y1 = g.offsetY - stoRate(v[0][2])/Math.pow(10, g.powerY) / g.stepY * g.scaleY;
        var y1 = g.offsetY - Math.multiply(stoRate(v[0][2]), Math.pow(10, Math.multiply(g.powerY, -1))) / g.stepY * g.scaleY;
    }else{
//        var y1 = g.offsetY - g.scaleY - (stoRate(v[0][2])/Math.pow(10, g.powerY) - g.minY) / g.stepY * g.scaleY;
        var y1 = g.offsetY - g.scaleY - (Math.multiply(stoRate(v[0][2]), Math.pow(10, Math.multiply(g.powerY, -1))) - g.minY) / g.stepY * g.scaleY;
    }
    for(var x=1;x<v.length;x++){
        x2 = (x + 1) * g.scaleX + g.offsetX;
        if(g.minY==0){
//            var y2 = g.offsetY - stoRate(v[x][2])/Math.pow(10, g.powerY) / g.stepY * g.scaleY;
            var y2 = g.offsetY - Math.multiply(stoRate(v[x][2]), Math.pow(10, Math.multiply(g.powerY, -1))) / g.stepY * g.scaleY;

        }else{
//            var y2 = g.offsetY - g.scaleY -  (stoRate(v[x][2])/Math.pow(10, g.powerY) - g.minY) / g.stepY * g.scaleY;
            var y2 = g.offsetY - g.scaleY -  (Math.multiply(stoRate(v[x][2]), Math.pow(10, Math.multiply(g.powerY, -1))) - g.minY) / g.stepY * g.scaleY;
        }
        var e = document.createElementNS(o,"line");
        e.setAttribute("stroke","#000000");
        e.setAttribute("stroke-width",3);
        e.setAttribute("x1",x1);
        e.setAttribute("y1",y1);
        e.setAttribute("x2",x2);
        e.setAttribute("y2",y2);
        svg.appendChild(e);
        x1 = x2;
        y1 = y2;
    }
}
